var _path, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSportsField(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 12V2.25C5 2.11193 5.11193 2 5.25 2H7.5M5 12V21.75C5 21.8881 5.11193 22 5.25 22H7.5M5 12H19M19 12V21.75C19 21.8881 18.8881 22 18.75 22H16.5M19 12V2.25C19 2.11193 18.8881 2 18.75 2H16.5M9.5 2V1.25C9.5 1.11193 9.61193 1 9.75 1H14.25C14.3881 1 14.5 1.11193 14.5 1.25V2M9.5 2H14.5M9.5 2H7.5M14.5 2H16.5M9.5 22V22.75C9.5 22.8881 9.61193 23 9.75 23H14.25C14.3881 23 14.5 22.8881 14.5 22.75V22M9.5 22H14.5M9.5 22H7.5M14.5 22H16.5M7.5 2V3.25C7.5 3.38807 7.61193 3.5 7.75 3.5H9M16.5 2V3.25C16.5 3.38807 16.3881 3.5 16.25 3.5H15M7.5 22V20.75C7.5 20.6119 7.61193 20.5 7.75 20.5H9M16.5 22V20.75C16.5 20.6119 16.3881 20.5 16.25 20.5H15M9 3.5C9 5.1 11 5.5 12 5.5C13 5.5 15 5.1 15 3.5M9 3.5H15M9 20.5C9 18.9 11 18.5 12 18.5C13 18.5 15 18.9 15 20.5M9 20.5H15",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 2.75,
    strokeWidth: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSportsField);
export default __webpack_public_path__ + "static/media/SportsField.a963fdd6ba8594d5e2fda1189ea49d51.svg";
export { ForwardRef as ReactComponent };